<template>
  <CelusButton v-bind="$attrs" color="primary" variant="flat">
    <slot />
  </CelusButton>
</template>

<script setup lang="ts">
import CelusButton from "@/components/util/CelusButton.vue";

defineOptions({
  name: "CelusPrimaryButton",
  inheritAttrs: false,
});
</script>
